var React = require('react');

function Asus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 9.36 9.156 30.373l9.775-6.185.005-.003 6.581-4.134L20 9.36zm7.358 14.257-3.607 2.267 7.094 4.488-3.486-6.755zM20 28.244 6.626 36.706c-2.154 1.362-4.727-.995-3.558-3.26l14.71-28.503c.932-1.804 3.513-1.804 4.444 0l14.711 28.503c1.169 2.265-1.404 4.622-3.558 3.26L20 28.244z","fill":"#fff"}));
}

Asus.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Asus;

Asus.default = Asus;
